import type { CSSProperties } from 'react';

export type ClassName = string | boolean | null | undefined;

export type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

/**
 * Cleans and combines a list of classNames into a string.
 *
 * @param ...classNames ClassName[]
 *
 * @returns string
 */
export function cn(...classNames: ClassName[]): string {
	return classNames
		.filter((n) => typeof n === 'string' && !!n === true)
		.join(' ');
}

/**
 * Convert key-value object into CSSProperties object with variable dash-prefix.
 *
 * @param styles Record<string, string>
 *
 * @returns CSSProperties
 */
export function cv(styles: Record<string, string>): CSSProperties {
	return Object.fromEntries(
		Object.entries(styles).map(([key, value]) => [`--${key}`, value])
	) as CSSProperties;
}
